import { render, staticRenderFns } from "./DashboardFormulaView.vue?vue&type=template&id=4a290c94&scoped=true&"
import script from "./DashboardFormulaView.vue?vue&type=script&lang=js&"
export * from "./DashboardFormulaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a290c94",
  null
  
)

export default component.exports